
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { SEO } from '../../utils/seo';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const siteUrl = 'https://jl-security.co.uk';

  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "JL Security",
    "image": "https://static.readdy.ai/image/74d1e4e79521c370342183571976e552/640721aa39941874b11ee1cb82c47c85.png",
    "description": "JL Security delivers practical security, risk management and compliance solutions across North Wales, the North West and UK-wide. Expert consultancy, accredited training, fire safety, security systems and Martyn\\'s Law readiness.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "North Wales",
      "addressRegion": "Wales",
      "addressCountry": "GB"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "53.2274",
      "longitude": "-4.1293"
    },
    "url": siteUrl,
    "telephone": "+447834561015",
    "email": "info@jl-security.co.uk",
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "14:00"
      }
    ],
    "sameAs": [
      "https://www.linkedin.com/in/john-lewis-753930124/",
      "https://www.facebook.com/profile.php?id=61585193507086"
    ],
    "areaServed": [
      { "@type": "Place", "name": "North Wales" },
      { "@type": "Place", "name": "North West England" },
      { "@type": "Place", "name": "United Kingdom" }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Security Risk Compliance Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Security Consultancy North Wales",
            "description": "Risk assessments, Martyn\\'s Law readiness, gap analysis, policies and ISO-aligned governance"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Fire Safety Solutions North Wales",
            "description": "Fire alarm systems, emergency lighting, fire risk assessments and BS 5839 compliance"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Security Systems Installation",
            "description": "CCTV, access control and intruder alarm systems with professional installation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Accredited Safety Training",
            "description": "First aid, fire safety, security operations and compliance training delivered online and on-site"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Event Security North Wales",
            "description": "SIA-licensed door supervisors, close protection and event security operations"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="JL Security | Security Risk Compliance Solutions North Wales &amp; UK"
        description="JL Security delivers practical security, risk management and compliance solutions across North Wales, the North West and UK-wide. Expert consultancy, accredited training, fire safety, security systems and Martyn's Law readiness."
        keywords="security consultancy North Wales, risk management, compliance solutions, fire safety North Wales, security systems, Martyn's Law"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <header>
          <Navbar isScrolled={isScrolled} />
        </header>
        <main>
          <HeroSection />
          <ServicesSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
}
